import { Button } from '@openx/components-core/lib/Button/Button';
import { useTranslation } from 'react-i18next';

export type AddButtonProps = {
  onOpenDrawerClick?: () => void;
  isDisabled?: boolean;
  pendoFeature?: string;
};

export const AddButton = ({ onOpenDrawerClick, isDisabled, pendoFeature }: AddButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="text"
      color="primary"
      type="button"
      onClick={onOpenDrawerClick}
      data-test="add-button"
      data-pendo-feature={pendoFeature}
      disabled={isDisabled}
    >
      {t('Add')}
    </Button>
  );
};
